module.exports = __webpack_public_path__ + "img/path-2.3339bbac.svg";